import { chatsService } from "@/_services";
export const chat = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    send: {
      data: [],
      status: {},
    },
    delete: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getError(state, error) {
      state.list.data = null;
      state.list.status = {
        error,
      };
    },
    deleteByIdRequest(state) {
      state.delete.status = {
        deleting: true,
      };
    },
    deleteByIdError(state, error) {
      state.delete.data = null;
      state.delete.status = {
        error,
      };
    },
    deleteByIdSuccess(state, response) {
      state.delete.data = response;
      state.delete.status = {
        deleted: true,
      };
    },
    sendRequest(state) {
      state.send.status = {
        sending: true,
      };
    },
    sendError(state, error) {
      state.send.data = null;
      state.send.status = {
        error,
      };
    },
    sendSuccess(state, response) {
      state.send.data = response;
      state.send.status = {
        sended: true,
      };
    },
  },
  actions: {
    get({ commit }, filters) {
      commit("getRequest");
      chatsService
        .get(filters)
        .then((response) => {
          commit("getSuccess", response);
        })
        .catch((error) => {
          commit("getError", error);
        });
    },
    deleteById({ commit }, id) {
      commit("deleteByIdRequest");
      chatsService
        .deleteById(id)
        .then((res) => {
          commit("deleteByIdSuccess", res);
        })
        .catch((error) => {
          commit("deleteByIdError", error);
        });
    },
    send({ commit }, request) {
      commit("sendRequest");
      chatsService
        .send(request)
        .then((res) => {
          commit("sendSuccess", res);
        })
        .catch((error) => {
          commit("sendError", error);
        });
    },
  },
};
